import CentumButton from 'components/MainPage/dcs/centumvp/components/Button/CentumButton';
import CentumInput from 'components/MainPage/dcs/centumvp/components/Input/CentumInput';
import CentumSelect from 'components/MainPage/dcs/centumvp/components/Select/CentumSelect';
import React, { useState } from 'react';
import { tabComponents } from '../SearchCondition';

interface IDate {}

function DateComponent(props: tabComponents) {
    const blockOpt = ['minutes', 'hours', 'days', 'weeks'];
    const buttonStyle = { width: '15px', height: '10px', padding: '1px', fontSize: '5px' };
    const [selectedValue, setSelectedValue] = useState<string | number>('');

    const displayEnabled = props.tempConfig.display.search;
    const date = props.tempConfig.date;

    // const handleSelectChange = (value: string | number) => {
    //     setSelectedValue(value);
    // };

    const SelectType = (mode: string) => {
        const updateConf = { ...props.tempConfig };
        updateConf.date.select(mode);
        props.SaveConfig(updateConf);
    };

    const handleDateChange = (type: 'between' | 'and', direction: 'up' | 'down') => {
        const updateConf = { ...props.tempConfig };
        const selectedDate = new Date(updateConf.date.specifiedDate[type].date);

        if (direction === 'up') {
            selectedDate.setDate(selectedDate.getDate() + 1);
        } else {
            selectedDate.setDate(selectedDate.getDate() - 1);
        }

        updateConf.date.specifiedDate[type].date = selectedDate.toISOString().split('T')[0];
        props.SaveConfig(updateConf);
    };

    const handleTimeChange = (type: 'between' | 'and', direction: 'up' | 'down') => {
        const updateConf = { ...props.tempConfig };
        const [hours, minutes] = updateConf.date.specifiedDate[type].time.split(':').map(Number);
        let date = new Date();
        date.setHours(hours);
        date.setMinutes(minutes);

        if (direction === 'up') {
            date.setMinutes(date.getMinutes() + 1);
        } else {
            date.setMinutes(date.getMinutes() - 1);
        }

        updateConf.date.specifiedDate[type].time = date.toTimeString().split(' ')[0].slice(0, 5);
        props.SaveConfig(updateConf);
    };

    const handlePastFormatChange = (value: any) => {
        const updateConf = { ...props.tempConfig };
        updateConf.date.past.format = value;
        props.SaveConfig(updateConf);
    };

    const handlePastNumberChange = (value: number, direction: 'up' | 'down') => {
        const updateConf = { ...props.tempConfig };
        if (direction == 'up') {
            updateConf.date.past.number = ++value;
        } else {
            updateConf.date.past.number = --value;
        }
        props.SaveConfig(updateConf);
    };

    return (
        <div
            style={{
                boxSizing: 'border-box',
                width: '100%',
                padding: '20px',
                fontSize: '12px',
                color: displayEnabled ? 'black' : '#808080',
                pointerEvents: displayEnabled ? 'auto' : 'none'
            }}>
            <RadioButton
                enable={!displayEnabled}
                checked={date.all}
                id="All"
                label="All"
                onChange={() => SelectType('all')}
            />
            <RadioButton
                enable={!displayEnabled}
                checked={date.specifiedDate.state}
                id="SpecifiedDate"
                label="Specified Date"
                onChange={() => SelectType('specifiedDate')}
            />
            <div style={{ padding: '5px 10px' }}>
                <div style={{ display: 'grid', padding: '0px 10px' }}>
                    <DateRangeInput
                        enable={date.specifiedDate.state}
                        date={date.specifiedDate.between.date}
                        time={date.specifiedDate.between.time}
                        displayEnabled={displayEnabled}
                        label="between"
                        buttonStyle={buttonStyle}
                        onDateChange={(direction) => handleDateChange('between', direction)}
                        onTimeChange={(direction) => handleTimeChange('between', direction)}
                    />
                    <DateRangeInput
                        enable={date.specifiedDate.state}
                        date={date.specifiedDate.and.date}
                        time={date.specifiedDate.and.time}
                        displayEnabled={displayEnabled}
                        label="and"
                        buttonStyle={buttonStyle}
                        onDateChange={(direction) => handleDateChange('and', direction)}
                        onTimeChange={(direction) => handleTimeChange('and', direction)}
                    />
                </div>
            </div>
            <div style={{ display: 'flex' }}>
                <RadioButton
                    enable={!displayEnabled}
                    checked={date.past.state}
                    id="Past"
                    label="Past"
                    onChange={() => SelectType('past')}
                />
                <div style={{ display: 'flex', padding: '2px 10px 2px 43px' }}>
                    <CentumInput
                        value={date.past.number}
                        enable={date.past.state && displayEnabled}
                        id={'Date'}
                        type="text"
                        width={100}
                        height={20}
                    />
                    <div style={{ fontSize: '5px', paddingRight: '15px' }}>
                        <CentumButton
                            disabled={!date.past.state || !displayEnabled}
                            name={'▲'}
                            onClick={() => handlePastNumberChange(date.past.number, 'up')}
                            style={buttonStyle}
                        />
                        <CentumButton
                            disabled={!date.past.state || !displayEnabled}
                            name={'▼'}
                            onClick={() => handlePastNumberChange(date.past.number, 'down')}
                            style={buttonStyle}
                        />
                    </div>
                    <CentumSelect
                        disabled={!date.past.state || !displayEnabled}
                        value={date.past.format}
                        options={blockOpt}
                        onChange={handlePastFormatChange}
                        width={70}
                        height={20}
                    />
                </div>
            </div>
        </div>
    );
}

export default DateComponent;

interface RadioButton {
    id: string;
    label: string;
    enable: boolean;
    checked: boolean;
    onChange: () => void;
}

function RadioButton({ id, label, enable, checked, onChange }: RadioButton) {
    return (
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
            <CentumInput enable={enable} checked={checked} onChange={onChange} type="radio" id={id} />
            <span>{label}</span>
        </div>
    );
}

interface DateRangeInput {
    date: string;
    time: string;
    label: 'between' | 'and';
    enable: boolean;
    displayEnabled: boolean;
    buttonStyle: React.CSSProperties;
    onDateChange: (direction: 'up' | 'down') => void;
    onTimeChange: (direction: 'up' | 'down') => void;
}

function DateRangeInput({
    label,
    enable,
    date,
    time,
    displayEnabled,
    buttonStyle,
    onDateChange,
    onTimeChange
}: DateRangeInput) {
    return (
        <div style={{ display: 'flex', padding: '2px 10px' }}>
            <span style={{ width: '50px', paddingRight: '5px' }}>{label}</span>
            <CentumInput
                value={date}
                enable={enable && displayEnabled}
                id={'Date'}
                type="text"
                width={100}
                height={20}
            />
            <div style={{ fontSize: '5px', paddingRight: '15px' }}>
                <CentumButton
                    disabled={!enable || !displayEnabled}
                    name={'▲'}
                    onClick={() => onDateChange('up')}
                    style={buttonStyle}
                />
                <CentumButton
                    disabled={!enable || !displayEnabled}
                    name={'▼'}
                    onClick={() => onDateChange('down')}
                    style={buttonStyle}
                />
            </div>
            <CentumInput
                value={time}
                enable={enable && displayEnabled}
                id={'Date'}
                type="text"
                width={50}
                height={20}
            />
            <div>
                <CentumButton
                    disabled={!enable || !displayEnabled}
                    name={'▲'}
                    onClick={() => onTimeChange('up')}
                    style={buttonStyle}
                />
                <CentumButton
                    disabled={!enable || !displayEnabled}
                    name={'▼'}
                    onClick={() => onTimeChange('down')}
                    style={buttonStyle}
                />
            </div>
        </div>
    );
}
